var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4 7.5576C4 5.5968 5.62419 4 7.61963 4H11.5885C13.5799 4 15.2 5.592 15.2 7.5496V16.4424C15.2 18.404 13.5758 20 11.5796 20H7.6123C5.62012 20 4 18.408 4 16.4504V15.6984V7.5576Z",
    fill: "#FA4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8228 11.5641L17.5462 9.23693C17.3109 8.99693 16.9322 8.99693 16.6977 9.23853C16.4639 9.48013 16.4647 9.86973 16.6992 10.1097L17.9466 11.3841H16.7507H10.0384C9.70728 11.3841 9.43848 11.6601 9.43848 12.0001C9.43848 12.3409 9.70728 12.6161 10.0384 12.6161H17.9466L16.6992 13.8905C16.4647 14.1305 16.4639 14.5201 16.6977 14.7617C16.8153 14.8825 16.9688 14.9433 17.1231 14.9433C17.2758 14.9433 17.4293 14.8825 17.5462 14.7633L19.8228 12.4369C19.9358 12.3209 19.9996 12.1641 19.9996 12.0001C19.9996 11.8369 19.9358 11.6801 19.8228 11.5641Z",
    fill: "#FA4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLogout);
export default __webpack_public_path__ + "static/media/red-logout.b45e46e7062bb8903ac224fdaa2bd138.svg";
export { ForwardRef as ReactComponent };